export default __webpack_public_path__ + "static/LinkedIn-60110a47906fa4b222fd80c5bf7545fb.svg";